import { PARTY_A, PARTY_B } from 'Common/constants';

const getOtherParty = owner => (owner === PARTY_A ? PARTY_B : PARTY_A);

export default getOtherParty;
